export default [{
  path: '/admin/institution/filesList',
  name: 'InstitutionFilesList',
  component: () => import('@/views/institution/files/list'),
  meta: {
    title: '档案列表',
    headType: 2,
    auth: true,
    routerType: 2
  }
}, {
  path: '/admin/institution/files/detail',
  name: 'InstitutionFilesDetail',
  component: () => import('@/views/institution/files/detail'),
  meta: {
    title: '档案详情',
    headType: 2,
    auth: true,
    routerType: 2
  }
}]



// WEBPACK FOOTER //
// ./src/router/institution/files.js